import React, { useEffect, useState } from 'react';
import { Dialog } from '@mui/material';
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import { ReactComponent as DonwloadIcon } from "assets/img/svg/downloadIcon.svg";
import { AGridColDef } from '../../../../common/data-grid/ADataGridColDef';
import ADataGrid from '../../../../common/data-grid/ADataGrid';
import { gridComponents, gridStyles } from '../../../issuanceIDcard/printIdCardAndMapRfid/constant';
import NoRowOverlay from '../../../../masters/holidayMaster/NoRowOverlay';
import ALoader from '../../../../common/a-loader';
import {downloadPdfFromBase64, fetchAllPostPromisedData, fetchAllPromisedData, getFormattedAmount } from '../../../../common/utils/methods/commonMethods/utilityMethod';
import { endpoint } from '../../../../common/constant';
import { getFormatedDate } from '../../../../unAssigned/concessionApproval/common';

export const downloadFileByS3Key = async (s3Key) => {
  const templateUrl = await fetchAllPostPromisedData(
    `${endpoint.fetchS3Url.getDownloadUrl}?key=${s3Key}`,
    {}
  );
  if (templateUrl?.code === 200 && templateUrl?.data) {
      window.open(`${templateUrl?.data?.url}`);
  }
}  

const ViewInvoiceDialog = ({
    dialogInfo,
    setDialogInfo,
    currentApplicationDetails = {}
}) => {


    const { psid, applicationId, businessAreaDispValue, businessAreaId } = currentApplicationDetails;

    const [invoiceList, setInvoiceList] = useState([]);
    const [loading, setLoading] = useState(false);

    const { isOpen, itemType } = dialogInfo;

    const closeDialog = () => setDialogInfo(prev => ({ ...prev, isOpen: false }));

    useEffect(() => {
        const fetchInvoiceList = async () => {
            try {
                setLoading(true);
                const invoiceList = await fetchAllPromisedData(
                    `${endpoint.invoice.getInvoiceDetailsByItemTypeNo}/${psid}?application=${applicationId}&bu=${businessAreaDispValue}&itemType=${itemType}`
                );
                setInvoiceList(invoiceList);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        }
        isOpen && fetchInvoiceList();
    }, [isOpen])


    const downloadInvoice = async (row) => {
        try {
            setLoading(true);

            const { invoiceId, type, invoiceNumber } = row;

            const req = {
                invoiceId,
                type,
                invoiceNumber,
                businessAreaValue: businessAreaDispValue,
                businessAreaId,
                psId : psid
            }

            const resp = await fetchAllPostPromisedData(`${endpoint.invoice.generateInvoicePdf}`, req);

            if (resp?.code === 200) {
                const { s3Key, pdfFile: pdfBase64String } = resp?.data;

                if (s3Key?.trim()) {
                    downloadFileByS3Key(s3Key);
                    return;
                }

                downloadPdfFromBase64(pdfBase64String, "Invoice.pdf");
            }

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }

    }

    const columns = [

        new AGridColDef("invoiceId", "Invoice Id", false)
            .setMinWidth(150)
            .setFlex(1)
            .setValueGetter((params) => params?.value),

        new AGridColDef("originalDueDate", "Original Due Date", false)
            .setMinWidth(140)
            .setFlex(1)
            .setValueGetter((params) => getFormatedDate(params?.value, false, 'DD/MM/YYYY')),

        new AGridColDef("invoiceDate", "Invoice Date", false)
            .setMinWidth(120)
            .setFlex(1)
            .setValueGetter((params) => getFormatedDate(params?.value, false, 'DD/MM/YYYY')),

        new AGridColDef("cgst", "CGST", false)
            .setMinWidth(100)
            .setFlex(1)
            .setValueGetter((params) => getFormattedAmount(params?.value)),

        new AGridColDef("sgst", "SGST", false)
            .setMinWidth(100)
            .setFlex(1)
            .setValueGetter((params) => getFormattedAmount(params?.value)),

        new AGridColDef("igst", "IGST", false)
            .setMinWidth(100)
            .setFlex(1)
            .setValueGetter((params) => getFormattedAmount(params?.value)),

        new AGridColDef("ugst", "UGST", false)
            .setMinWidth(100)
            .setFlex(1)
            .setValueGetter((params) => getFormattedAmount(params?.value)),

        new AGridColDef("serviceTax", "Service Tax", false)
            .setMinWidth(120)
            .setFlex(1)
            .setValueGetter((params) => getFormattedAmount(params?.value)),

        new AGridColDef("billedAmount", "Billed Amount", false)
            .setMinWidth(140)
            .setFlex(1)
            .setValueGetter((params) => getFormattedAmount(params?.value)),

        new AGridColDef("invoiceType", "Invoice Type", false)
            .setMinWidth(160)
            .setFlex(1)
            .setValueGetter((params) => params?.value),

        new AGridColDef("action", "Action", false)
            .setMinWidth(80)
            .setFlex(0.5)
            .renderCellComponent(params =>
                <DonwloadIcon className='cursor' onClick={() => downloadInvoice(params?.row)} />
            )
    ];

    return (
        <Dialog
            open={isOpen}
            fullWidth
            maxWidth="lg"
        >
            <div className='d-flex flex-column m-3'>

                {loading && <ALoader position={"fixed"} />}

                <div className='d-flex justify-content-between'>
                    <h2 className='color-dark'>Invoice Details {`(${itemType})`}</h2>
                    <CrossIcon onClick={closeDialog} />
                </div>

                <ADataGrid
                    removeWrapperContainer
                    rows={invoiceList || []}
                    columns={columns}
                    rowId={(row) => JSON.stringify(row)}
                    rowHeight={50}
                    components={{
                        ...gridComponents,
                        NoRowsOverlay: () => (
                            <NoRowOverlay message={loading ? "Loading..." : null} />
                        ),
                    }}
                    sx={gridStyles}
                    hidePagination
                    autoHeight
                />



            </div>

        </Dialog>
    );
}

export default ViewInvoiceDialog;